import { Drawer, Grid } from '@mui/material';
import React from 'react'
import globalStyles from './../../../../../../../assets/styles/global.module.scss'
import ReplyIcon from '@mui/icons-material/Reply';
import ListIcon from '@mui/icons-material/List';
import CallIcon from '@mui/icons-material/Call';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import styles from './../../../../../../../assets/styles/componentStyles/chatLogsStyles/chatLogsTemplatePreview.module.scss'
import CloseIcon from '@mui/icons-material/Close';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { subButtonTypeIconMap } from '../../../../../templatelibrary/constant';
import { BTN_SUB_TYPE_NAMES } from '../utils';

interface templateButtonPreview {
    buttons: any,
    targetRef?: any,
    previewType: string
}

const TemplateButtonPreview = (props: templateButtonPreview) => {
    const { buttons, targetRef, previewType } = props;
    const [open, setOpen] = React.useState(false);

    const toggleDrawer1 = (newOpen: any) => () => {
        setOpen(newOpen);
    };

    // const getSubButtonIcon = (whatsapp_template_button_sub_type_id: number | string) => {
    //     let subId = Number(whatsapp_template_button_sub_type_id)
    //     switch (subId) {
    //         case 3:
    //             return <OpenInNewOutlinedIcon style={{ display: "flex" }} className={styles.previewSubButton} />;
    //         case 4:
    //             return <CallIcon style={{ display: "flex" }} className={styles.previewSubButton} />
    //         case 2:
    //             return <ReplyIcon style={{ display: "flex" }} className={styles.previewSubButton} />
    //         case 1:
    //             return <ReplyIcon style={{ display: "flex" }} className={styles.previewSubButton} /> 
    //         case 7: 
    //             return <AssignmentIcon style={{ display: "flex" }} className={styles.previewSubButton} />
    //         case 8:
    //             return <ContentCopyIcon style={{ display: "flex" }} className={styles.previewSubButton} />
    //         case null:
    //             return ""
    //         default:
    //             return <ListIcon style={{ display: "flex" }} className={styles.previewSubButton} />
    //     }
    // }

    const handleCampaignButtonText = (subBtnData: any) => {
        let fieldVal = subBtnData.whatsapp_template_button_sub_type_field_data.filter((field: any) => field.field_name == "Button Text")[0]
        switch (fieldVal.field_static_value_flag) {
            case true:
                return fieldVal.field_static_value
            case false:
                return fieldVal.whatsapp_template_button_sub_type_field_value
            default:
                return ""
        }
    }

    const chatlogsButtonText = (subBtnData: any) => {
        let fieldVal = subBtnData?.wa_button_field_data?.filter((field: any) => field.field_name == "Button Text")[0]
        return fieldVal?.wa_template_button_sub_type_field_value
    }

    const chatLogsButtonDescription = (subBtnData: any) => {
        let fieldVal = subBtnData?.wa_button_field_data?.filter((field: any) => field.field_name.toLowerCase() == "button description")[0];
        
        return fieldVal?.wa_template_button_sub_type_field_value || "";
    } 

    const campaignButtonDescription = (subBtnData: any) => {
        let fieldVal = subBtnData.whatsapp_template_button_sub_type_field_data.filter((field: any) => field.field_name.toLowerCase() == "button description")[0]
        return fieldVal?.whatsapp_template_button_sub_type_field_value || "";
    }

    const getSubButtonText = (subBtnData: any) => {
        let type = previewType?.toLowerCase()
        switch (type) {
            case "campaign":
                return handleCampaignButtonText(subBtnData)
            case "chatlogs":
                return chatlogsButtonText(subBtnData)
        }
    }

    const getButtonDescriptionText = (subBtnData: any) => {
        let type = previewType?.toLowerCase()
        switch (type) {
            case "campaign":
                return campaignButtonDescription(subBtnData)
            case "chatlogs":
                return chatLogsButtonDescription(subBtnData)
        }
    }

    const handleUpdatedButtons = () => {
        let type = previewType?.toLowerCase()
        switch (type) {
            case "campaign":
                if (buttons?.length > 0 && buttons.flatMap((btn: any) => btn.whatsapp_template_button_data).length <= 3) {
                    return buttons.flatMap((btn: any) => btn.whatsapp_template_button_data)
                }
                else if (buttons?.length > 0 && buttons.flatMap((btn: any) => btn.whatsapp_template_button_data).length > 3) {
                    return buttons.flatMap((btn: any) => btn.whatsapp_template_button_data).splice(0, 2)
                }
                return
            case "chatlogs":
                if (buttons?.length > 0 && buttons?.length <= 3) {
                    return buttons
                }
                else if (buttons?.length > 3) {
                    return buttons?.slice(0, 2)?.sort((button1: any, button2: any) => button1.index - button2.index)
                }
                return buttons
        }
    }

    const handleKeyForIcon = () => {
        let type = previewType?.toLowerCase()
        switch (type) {
            case "campaign":
                return {
                    id: "whatsapp_template_button_sub_type_id",
                    name: "whatsapp_template_button_sub_type_name"
                }
            case "chatlogs":
                return {
                    id: "wa_template_button_sub_type_id",
                    name: "wa_template_button_sub_type_name"
                }
            default:
                return {
                    id: '', name: ''
                }
        }
    }

    return (
        <Grid container direction="column" dir="ltr">
            {handleUpdatedButtons()?.map((btnData: any) => {
                return <Grid item padding={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder} ${globalStyles.fullwidth}`}>
                    <Grid container justifyContent={"center"} gap={1} alignItems={"center"} flexWrap={"nowrap"}>
                        {btnData[handleKeyForIcon()?.name] !== BTN_SUB_TYPE_NAMES['VIEW_CATALOG'] && 
                            <Grid item className={previewType === "chatlogs" ? styles.inboxButtonIconSmall : undefined}>
                                {subButtonTypeIconMap[btnData?.[previewType === "chatlogs" ? "wa_template_button_sub_type_name" : "whatsapp_template_button_sub_type_name"]?.toLowerCase() as keyof typeof subButtonTypeIconMap]}
                            </Grid>
                        }
                        <Grid item> 
                            <Grid container direction={"column"}>
                                <Grid item>
                                    {getSubButtonText(btnData)}
                                </Grid>
                                <Grid item className={styles.templatePreviewBtnDescription}>
                                    {getButtonDescriptionText(btnData)}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            })}

            {buttons?.length > 3 &&
                <Grid item paddingBlock={"12px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder} ${globalStyles.fullwidth}`}
                    onClick={toggleDrawer1(true)}
                >
                    <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                        <Grid item>
                            <MenuIcon style={{ display: "flex" }} />
                        </Grid>
                        <Grid item>
                            See all options
                        </Grid>
                    </Grid>
                </Grid>
            }

            {/* {handleUpdatedButtons()?.map((btnData: any, ind: number) => {
                return <Grid item key={ind} paddingBlock={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                    <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                        <Grid item>
                            {getSubButtonIcon(btnData.wa_template_button_sub_type_id)}
                        </Grid>
                        <Grid item>
                            {getSubButtonText(btnData)}
                        </Grid>
                    </Grid>
                </Grid>
            })} */}

            {previewType != "campaign" && 
                <Drawer
                    open={open}
                    anchor='bottom'
                    ref={targetRef ? targetRef.current : ""}
                    onClose={toggleDrawer1(false)}
                    variant="temporary"
                    ModalProps={{
                        container: targetRef ? targetRef.current : "",
                        disableEnforceFocus: true,
                        style: { position: 'absolute' },
                        keepMounted: false,
                    }}
                    PaperProps={{
                        container: targetRef ? targetRef.current : "",
                        style: { position: 'absolute' },
                    }}
                   className={styles.buttonDrawer}
                    BackdropProps={{ style: { position: "absolute" } }}
                    SlideProps={{
                        direction: open ? "up" : "down",
                        timeout: { enter: 0, exit: 0 },
                        className: styles.buttonDrawerSlideStyle
                    }}
                >
                    <Grid container direction={"column"} gap={"18px"} marginBottom={"15px"}>
                        <Grid item xs={12} className={`${styles.drawerContainerBoxStyle} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter}`} gap={"12px"}>
                            <CloseIcon className={styles.closeDrawerIconStyle} onClick={() => setOpen(false)} />
                            <span className={styles.allOptionTextStyle}>All Options</span>
                        </Grid>
                    </Grid>
                    {buttons?.length > 0 && buttons?.sort((button1: any, button2: any) => button1.index - button2.index)?.map((btnData: any) => {
                        return <Grid item padding={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                            <Grid container gap={1} alignItems={"center"} flexWrap={"nowrap"}>
                                <Grid item>
                                    {subButtonTypeIconMap[btnData?.[previewType === "chatlogs" ? "wa_template_button_sub_type_name" : "whatsapp_template_button_sub_type_name"]?.toLowerCase() as keyof typeof subButtonTypeIconMap]}
                                </Grid>
                                <Grid item>
                                    <Grid container direction={"column"}>
                                        <Grid item>
                                            {getSubButtonText(btnData)}
                                        </Grid> 
                                        <Grid item className={styles.templatePreviewBtnDescription}>
                                            {getButtonDescriptionText(btnData)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    })}
                </Drawer>
            }
        </Grid>
    )
}

export default TemplateButtonPreview
